import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';
import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { uploadMultipleToImgBB } from '../../utils/imgbbUpload';
import { Upload } from 'react-feather';

export const ReportUser = () => {
  const { userId, requestId } = useParams();
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [reportedUserName, setReportedUserName] = useState('Unknown');
  const reportTypes = ['Inappropriate behavior', 'Harassment', 'Spam', 'Fake profile', 'Other'];

  // FIX: Changed useState to useEffect. 
  // useEffect runs whenever userId changes, ensuring the name loads correctly.
  useEffect(() => {
    if (userId) {
      getDoc(doc(db, 'users', userId)).then(snap => { 
        if (snap.exists()) setReportedUserName(snap.data().displayName || 'Unknown'); 
      });
    }
  }, [userId]);

  const handleFileChange = (e) => setFiles([...files, ...Array.from(e.target.files)]);
  const removeFile = (i) => setFiles(files.filter((_, idx) => idx !== i));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason || !description) return alert('Please fill in all fields');
    setLoading(true); 
    setUploading(true);
    try {
      let attachments = [];
      if (files.length > 0) attachments = await uploadMultipleToImgBB(files);
      
      await addDoc(collection(db, 'reports'), {
        reportedUserId: userId || null, 
        reportedRequestId: requestId || null,
        reportedUserName, 
        reportedId: user.uid, 
        reporterName: profile.displayName,
        reporterEmail: user.email, 
        reason, 
        description, 
        attachments,
        status: 'pending', 
        createdAt: serverTimestamp()
      });
      alert('Report submitted! Teachers will review this.');
      navigate(userId ? `/profile/${userId}` : -1);
    } catch (err) { 
      console.error('Report Error:', err); // This will show the exact error in console
      alert('Error: ' + err.message); 
    } finally { 
      setLoading(false); 
      setUploading(false); 
    }
  };

  return (
    <div className="report-page">
      <Card className="report-card">
        <h2>🚨 Report {userId ? reportedUserName : 'Request'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>Reason</label><select value={reason} onChange={e => setReason(e.target.value)} required><option value="">Select...</option>{reportTypes.map(t => <option key={t} value={t}>{t}</option>)}</select></div>
          <div className="form-group"><label>Description</label><textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Describe what happened..." rows="4" required /></div>
          <div className="form-group"><label>Attach Evidence (Optional)</label><label style={{display:'flex', alignItems:'center', gap:10, padding:12, border:'2px dashed #ddd', borderRadius:8, cursor:'pointer', background:'#f9fafb'}}><Upload size={18} /><span>Click to upload</span><input type="file" multiple accept="image/*,.pdf,.doc,.docx" onChange={handleFileChange} style={{display:'none'}} /></label>{files.length > 0 && <div style={{marginTop:8}}>{files.map((f,i) => <div key={i} style={{display:'flex', justifyContent:'space-between', padding:6, background:'#f3f4f6', borderRadius:4, marginBottom:4, fontSize:13}}><span> {f.name}</span><button type="button" onClick={() => removeFile(i)} style={{color:'red', background:'none', border:'none', cursor:'pointer'}}>✕</button></div>)}</div>}</div>
          <div className="btn-group"><Button type="button" onClick={() => navigate(-1)} className="btn-outline">Cancel</Button><Button type="submit" disabled={loading || uploading} className="btn-primary">{uploading ? 'Uploading...' : loading ? 'Submitting...' : 'Submit Report'}</Button></div>
        </form>
      </Card>
    </div>
  );
};
